import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { renderMarkdownToHtml } from '@/lib/render-markdown';
import { authMiddleware } from '@/lib/server-fn-auth';

/**
 * Renders markdown to sanitized HTML on the server. Moving this off the client
 * keeps `marked` + `isomorphic-dompurify` out of the browser bundle. POST so
 * large documents (resumes, cover letters) travel in the body, not the URL.
 */
export const renderMarkdown = createServerFn({ method: 'POST' })
  .middleware([authMiddleware])
  .inputValidator(z.object({ md: z.string() }))
  .handler(async ({ data }) => ({ html: renderMarkdownToHtml(data.md) }));
